import * as validationLib from "../../lib/validation";
import cn from "../../lib/classnames";
import gradientStyles from "../../styles/Gradient.module.css";
import React from "react";
import styles from "./CheckboxEnhanced.module.css";
import textStyles from "../../styles/Text.module.css";

type Props = React.ComponentProps<"input"> & {
    children?: React.ReactNode;
    label: string;
    hasGradient?: boolean;
    isChecked: boolean;
    className?: string;
    classNameLabel?: string;
    validationMessage?: string[];
    optionalFrontBoldLabel?: string;
};

function CheckboxEnhanced(
    {
        children,
        label,
        hasGradient = false,
        isChecked,
        className,
        classNameLabel,
        validationMessage,
        optionalFrontBoldLabel,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    return (
        <>
            <div
                className={cn(
                    hasGradient ? styles.gradientContainer : undefined,
                    hasGradient ? gradientStyles.grey : undefined,
                    className,
                )}
            >
                <label className={cn(textStyles.inputPlaceholder, styles.labelContainer)}>
                    <input
                        className={styles.input}
                        checked={isChecked}
                        {...rest}
                        type="checkbox"
                        ref={ref}
                    />
                    <div className={cn(styles.checkbox, isChecked ? styles.checked : undefined)} />
                    {optionalFrontBoldLabel ? (
                        <div className={cn(styles.label, classNameLabel)}>
                            <span className={styles.bold}>{optionalFrontBoldLabel}</span>
                            {label}
                            {children}
                        </div>
                    ) : (
                        <div className={cn(styles.label, classNameLabel)}>
                            {label}
                            {children}
                        </div>
                    )}
                </label>
            </div>
            {validationMessage && validationMessage.length ? (
                <div className={cn(textStyles.inputError, styles.validation)}>
                    {validationLib.getDisplayString(validationMessage)}
                </div>
            ) : null}
        </>
    );
}

export default React.forwardRef<HTMLInputElement, Props>(CheckboxEnhanced);
